<ng-container *ngIf="!result; else paymentSuccess">
  <div class="text-residential-content">
    <div class="residential-large-text">
      <p [innerHTML]="'total_premium.congrats_title' | translate"></p>
      <span class="registration-accent payment-price" [ngClass]="{'registration-accent_freeway': (customRmPage$ | async) === 'freeway'}">
        <img src="./assets/images/underline.svg" alt="blue line" class="underline">
        <ng-container *ngIf="data.invoices.length > 0">{{ data?.invoices[0]?.total_payable | stripeCurrency }}</ng-container>
      </span>
    </div>
    <div class="residential-large-text residential-pay-afterwards" *ngIf="selectedPaymentPlan && selectedPaymentPlan.title === 'Monthly'">
      <p>
        {{ data?.invoices[1]?.total_payable | stripeCurrency }} {{ 'total_premium.pay_afterwards' | translate }}
      </p>
    </div>
    <p class="residential-content-description">
      {{ 'form.price_includes_taxes_and_fees' | translate }}
    </p>
  </div>

  <form class="residential-form-main multy-result" [class.disable-events]="loader">
    <div *ngIf="loading" class="residential-payment__spinner-container">
      <mat-spinner></mat-spinner>
    </div>

    <div class="left-result">
      <app-payment-new-carrier
        *ngIf="!isQBE"
        [data]="data"
        [address]="residentialForm.policy_users_attributes[0].user_attributes.address_attributes"
        [hasBackButton]="hasBackButton"
        [loading]="loader"
        [agreeWithDisclosureParent]="newCarrierAgree"
        [subjectFormSubmit]="subjectFormSubmit"
        (cardStart)="loader = true"
        (cardError)="loader = false"
        (cardSuccess)="processPayment($event)"
        (openDisclosure)="goToDisclosure()"
        (declinePayment)="decline()">
      </app-payment-new-carrier>
      <app-st-elements-qbe
        *ngIf="isQBE"
        [totalPayable]="data?.invoices[0]?.total_payable"
        [loading]="loader"
        [hasBackButton]="hasBackButton"
        (cardFilled)="goToDisclosureQBE($event)"
        (cardComplete)="cardComplete.emit($event)"
        (declinePayment)="decline()">
      </app-st-elements-qbe>

      <powered-by-gc *brandingAttr="'powered_by_gc_footer'" class="powered-by"></powered-by-gc>
    </div>
    <div class="right-result">
      <div class="residential-payment__payment-plan-container">
        <mat-form-field *ngIf="paymentPlans" appearance="outline">
          <mat-label>{{'total_premium.billing_period' | translate}}</mat-label>
          <mat-select required [ngModel]="selectedPaymentPlan" [ngModelOptions]="{standalone: true}" (valueChange)="onPaymentPlanChanged($event)">
            <mat-option *ngFor="let plan of paymentPlans" [value]="plan">{{('form.' + (plan.title | lowercase)) | translate | titlecase }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <table class="residential-table-details">
        <thead>
        <tr>
          <td colspan="2" class="title">{{ 'form.premium_breakdown' | translate }}</td>
        </tr>
        </thead>
        <tr>
          <td>{{'total_premium.total_policy_premium' | translate}}</td>
          <td>{{data.quote.premium.total_premium | stripeCurrency}}</td>
        </tr>
        <tr>
          <td>{{ 'form.taxes' | translate }}</td>
          <td>{{data.quote.premium.total_tax | stripeCurrency}}</td>
        </tr>
        <tr>
          <td *ngIf="!isQBE">{{'total_premium.installment_fees' | translate}}**</td>
          <td *ngIf="isQBE">{{'total_premium.additional_fees' | translate}}**</td>
          <td>{{data.quote.premium.total_fee | stripeCurrency}}</td>
        </tr>
        <tr>
          <td>{{ ('total_premium.total_annual_cost' | translate)}}</td>
          <td>{{data.quote.premium.total | stripeCurrency}}</td>
        </tr>
        <tr *ngIf="selectedPaymentPlan && selectedPaymentPlan.title">
          <td>{{ ('total_premium.payment_schedule' | translate)}}</td>
          <td>{{ selectedPaymentPlan.title }}</td>
        </tr>
        <tr>
          <td>{{ ('total_premium.pay_today' | translate)}}</td>
          <td>{{data?.invoices[0]?.total_payable | stripeCurrency}}</td>
        </tr>
        <tr>
          <td colspan="2" class="subscription">
            {{ ('total_premium.est_premium_schedule' | translate) }}
            <p>{{'total_premium.a_detailed_list_of_all_payments' | translate}}</p>
          </td>
        </tr>
      </table>

      <mat-accordion class="total-premium-invoices-accordion">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="total-premium-invoices-accordion__title">
                {{ 'total_premium.payment_schedule' | translate }}
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <table class="residential-table-details">
            <tr>
              <td>{{ 'user.due_date' | translate }}</td>
              <td>{{ 'user.amount_due' | translate }}</td>
            </tr>
            <tr *ngFor="let item of data.invoices; let i = index;">
              <td>{{item.due_date | localizedDate:'MMM dd, yyyy' | titlecase}}</td>
              <td>{{item.total_payable | stripeCurrency}}
                <span *ngIf="i === 0">*</span>
              </td>
            </tr>
          </table>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <powered-by-gc *brandingAttr="'powered_by_gc_footer'" class="powered-by-mobile"></powered-by-gc>
  </form>
  <div *ngIf="!isQBE">
    <div style="margin: 0 auto;">
      <p style="font-size: 11px; margin-bottom: 10px">
        {{ 'residential.disclosure_block' | translate }}
      </p>
      <p style="font-size: 11px; margin-bottom: 10px">
        {{ 'residential.disclosure_block' | translate }}
    </p>
    <p style="font-size: 11px; margin-bottom: 10px">
      {{ 'total_premium.first_ins_fee' | translate}}
      </p>
      <p style="font-size: 11px; margin-bottom: 10px">
        {{ 'total_premium.monthly_scheduled' | translate }}
      </p>
      <p style="font-size: 11px;">*{{'total_premium.first_payment' | translate}}</p>
      <p style="font-size: 11px;">**{{ 'total_premium.a_fee_of' | translate }} {{data.installment_fee | stripeCurrency}} {{ 'total_premium.per_installment_will' | translate }}</p>
    </div>
    <div class="row legal-notice" style="margin: 0 auto;">
      <div class="col-xs-12">
        <h6>{{ 'total_premium.legal_notices' | translate }}</h6>
        <app-total-premium-states [state]="addressData.state"></app-total-premium-states>

        <p>{{ 'total_premium.by_clicking_submit_payment' | translate }} <a target="_blank" [routerLink]="['/Terms-of-Use']">{{ 'total_premium.terms_conditions' | translate }}</a>.</p>
        <a href="javascript:void(0)" style="text-decoration: underline" (click)="goToDisclosure()">{{ 'total_premium.click_here_disclosure' | translate }}</a>
      </div>
    </div>
  </div>
  <div *ngIf="isQBE" class="qbe-disclosure">
    <div style="margin: 0 auto;">
      <p style="font-size: 11px; margin-bottom: 10px">
        {{'residential.disclosure_block_qbe' | translate}}
      </p>
      <p style="font-size: 11px; margin-bottom: 10px">
        {{'total_premium.detailed_listing_of_all_policy_coverages' | translate}}
      </p>
      <p style="font-size: 11px; margin-bottom: 10px">
        {{'total_premium.when_choosing_the_monthly_payment' | translate}}
      </p>
      <p style="font-size: 11px; margin-bottom: 10px">
        {{'total_premium.policy_will_automatically_renew_after_one_year' | translate}}
      </p>
      <p style="font-size: 11px;">*{{'total_premium.first_payment' | translate}}</p>
      <p style="font-size: 11px;">**{{ 'total_premium.a_25_non_refundable_policy_fee' | translate }}</p>
    </div>
    <div class="row legal-notice" style="margin: 0 auto;">
      <div class="col-xs-12">
        <h6>{{ 'total_premium.legal_notices' | translate }}</h6>
        <app-total-premium-states [state]="addressData.state"></app-total-premium-states>

        <p>{{ 'total_premium.by_clicking_submit_payment' | translate }} <a target="_blank" [routerLink]="['/Terms-of-Use']">{{ 'total_premium.terms_of_use' | translate }}</a>.</p>
        <a href="javascript:void(0)" style="text-decoration: underline" (click)="goToDisclosureQBE(null)">{{ 'total_premium.click_here_disclosure' | translate }}</a>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #paymentSuccess>
  <app-success-policy [policyDetails]="policyDetails"></app-success-policy>
</ng-template>
